@if (tableData() && tableData().length > 0) {
  <nz-table
    nzTableLayout="auto"
    [nzData]="tableData()"
    [nzTotal]="totalCount"
    [nzPageIndex]="pageIndex"
    [nzPageSize]="pageSize"
    [nzShowPagination]="true"
    [nzHideOnSinglePage]="true"
    [nzFrontPagination]="false"
    [nzTitle]="tableTitle ?? null"
    [nzScroll]="{y: tableScrollYCalculationCss()}"
    (nzPageIndexChange)="changePageIndex($event)"
    nzSize="middle"
    class="tw-shadow-table-shadow"
    >
    <thead class="tw-relative">

      <ng-content select="table-header-groups"></ng-content>

      <tr class="tw-sticky tw-z-[10]" [ngClass]="{'tw-top-0': !tableHeaderGroupsExist}" [style.top.px]="tableHeaderGroupHeight">
        @for (column of columns; track column.id; let idx = $index) {

          <th [class]="'tw-p-0 ' + column.id" [title]="column.name" [nzEllipsis]="!column.width" [attr.data-key]="column.id + '_' + (sortKey ?? 'none')">
            <div [style.min-width]="column.width ?? 'auto'"
              [attr.data-sort-key]="column.sortable ? sortKey: null"
              class="tw-flex tw-gap-6 tw-items-center tw-h-[72px] tw-bg-default-gradient tw-bg-purple-100 tw-px-2 tw-py-4"
                 [ngClass]="{'tw-border-r-2 tw-border-purple-350': addRightBorderForColumnCollection.length && addRightBorderForColumnCollection?.includes(idx),
               'tw-rounded-tl-lg': idx === 0 && !tableHeader, 'tw-rounded-tr-lg': idx === columns.length - 1 && !tableHeader,
                'tw-text-aqua': !isSortReset && sortKey !== null && sortKey === column.id,
               'tw-cursor-pointer': column.sortable
               }">
              <div (click)="column.sortable ? onSort(column) : null">
                <p>{{ column.name }}</p>
                @if (column.label) {
                  <p class="tw-font-normal">{{ column.label }}</p>
                }
              </div>
            </div>
          </th>

        }
      </tr>
    </thead>
    <tbody>
      @for (row of tableData(); track row.productId; let rowIdx = $index; let firstRow = $first; let lastRow = $last) {

        <tr
          [class]="(firstRow && firstRowConfig! && !expandableCollapsibleRows) ? firstRowConfig!.class : (!expandableCollapsibleRows && (rowIdx % 2 === 0)) ? 'tw-bg-purple-50' : 'tw-bg-white'"
          [ngClass]="{'tw-sticky tw-top-[72px] tw-z-[10]': firstRowConfig && firstRowConfig.isSticky! && firstRow, '!tw-bg-purple-100': row?.selected || !row?.collapsed, '[&>*]:tw-border-purple-350 [&>*]:tw-border-b-2': expandableCollapsibleRows && row?.collapsed && !lastRow}">

          @for (header of columns; track header.id; let headerIdx = $index) {

            <ng-container
            *ngTemplateOutlet="tableCells; context: {header: header, headerIdx: headerIdx, row: row, rowIdx: rowIdx, firstRow: firstRow, rowRole: 'PARENT', hasNestedRows: !!row?.cabins?.length}"></ng-container>

          }

        </tr>
        @if (row?.cabins?.length && expandableCollapsibleRows && !row.collapsed) {
          @for (subRow of row['cabins']; track subRow; let subRowIdx = $index; let firstSubRow = $first; let lastSubRow = $last) {

            <tr class="tw-transition-all tw-h-[50px] tw-cursor-pointer" [class]="(subRowIdx % 2 === 0) ? 'tw-bg-purple-50' : 'tw-bg-white'"
                [ngClass]="{'!tw-bg-purple-250': subRow?.selected, 'tw-hidden': row?.collapsed, 'tw-table-row': !row?.collapsed,
                '[&>*]:tw-border-b-2 [&>*]:tw-border-purple-350': !row?.collapsed && lastSubRow
                }"
              >

              @for (header of columns; track header.id; let headerIdx = $index) {
                <ng-container
                *ngTemplateOutlet="tableCells; context: {header: header, headerIdx: headerIdx, parentRow:row,row: subRow, rowIdx: rowIdx, firstRow: firstSubRow, rowRole: 'CHILD',subRowIdx:subRowIdx}"></ng-container>

              }

            </tr>
          }
        }

      }
    </tbody>
  </nz-table>
} @else {
  <div class="empty-container">
    <div class="empty-table">
      <img src="../../../../assets/images/Property.png" alt="no data">
    </div>
    <div class="d-flex justify-content-center">
      <h4 class="mt-2">{{ 'common.noData' | translate }}</h4>

    </div>
  </div>
}

<ng-template #tableTitle>
  <div class="tw-bg-purple-100 tw-px-6 tw-py-4 tw-rounded-t-lg tw-flex tw-justify-between tw-items-center" [ngClass]="{'tw-hidden': !tableHeader}">
    <div class="tw-flex tw-items-center tw-gap-4">
      <ng-content select="table-header-buttons"></ng-content>
      <div class="tw-text-xs tw-text-text" [innerHTML]="tableHeader"></div>
    </div>
    <ng-content select="table-header-buttons-right"></ng-content>
  </div>
</ng-template>

<!-- rowRole = PARENT or CHILD -->
<ng-template #tableCells let-header="header" let-headerIdx="headerIdx" let-row="row" let-rowIdx="rowIdx" let-firstRow="firstRow"
  let-role="rowRole" let-hasNestedRows="hasNestedRows" let-parentRow="parentRow" let-subRowIdx="subRowIdx">
  <td [id]="header.id" nzEllipsis [class]="'tw-px-2 ' + header.id" [ngClass]="{
            'tw-py-4': !expandableCollapsibleRows,
            'tw-py-2': expandableCollapsibleRows,
            'tw-pl-8': headerIdx===0 && expandableCollapsibleRows && role !== 'PARENT',
            'tw-border-r-2 tw-border-purple-350': addRightBorderForColumnCollection.length && addRightBorderForColumnCollection?.includes(headerIdx),
            'tw-font-bold': (header.type === 'link' && role!=='PARENT') || validateCellsColumnsKey?.includes(header.id) && validateCellsRows!.includes(rowIdx),
            'tw-text-green-700': ((header.type === 'link' && !firstRow && firstRowConfig!) || header.type === 'link') && role!=='PARENT',
            'tw-text-right': header.align === 'right',
            'tw-text-center': header.align === 'center',
            'tw-text-purple': validateCellsColumnsKey?.includes(header.id) && validateCellsRows?.includes(subRowIdx) ,
            'tw-text-left': header.align === 'left',

            'empty-cell':expandableCollapsibleRows && role==='CHILD' && (headerIdx===0 || headerIdx===1 || headerIdx===2 || headerIdx===3)
            }"
    [style]="{backgroundColor: (coloredCellsColumnsKey?.includes(header.id) && !row.isDisabled) ? row.color : ''}"
    (click)="!disableSelectBehavior ? onSelectRowHandler(row,role === 'PARENT' ? row['productId']: parentRow['productId']) : null"
    >
    @if(expandableCollapsibleRows && role==='CHILD' && (headerIdx===0 || headerIdx===1 || headerIdx===2 || headerIdx===3)){
      }@else{
      <div [hidden]="getRowExceptionRules(rowIdx, headerIdx)?.hide"
        [class]="(row.class && !row.isDisabled) ? row.class : ''"
        [ngClass]="{'tw-inline-flex tw-items-center tw-gap-3': expandableCollapsibleRows && header?.nestedRowTrigger && role === 'PARENT' && hasNestedRows}"
        [ngStyle]="{textAlign: getRowExceptionRules(rowIdx, headerIdx)?.textAlign, width: header.width, whiteSpace: header.width ? 'normal' : 'inherit'}">

        <ng-template #tooltip>
          <div [innerHtml]="row['tooltip' + header.id]"></div>
        </ng-template>
        <!-- Nested row trigger -->
        @if (expandableCollapsibleRows && header?.nestedRowTrigger && role === "PARENT" && hasNestedRows) {
          <i class="bi bi-chevron-down tw-cursor-pointer tw-px-0.5 tw-py-1" (click)="handleExpandCollapseChange($event,rowIdx)"
          (mouseover)="handleOnMouseoverInputField()" (mouseleave)="handleOnMouseleaveInputField()"></i>
        }
        <!-- /Nested row trigger -->
        <span [style.cursor]="header.type === 'link' && 'pointer'"
            [ngClass]="[
                        header.align === 'right' ? 'tw-text-right'
                          : header.align === 'center' ? 'tw-text-center'
                          : 'tw-text-left',
                        header?.styleClass || header?.className || '',
                        (coloredCellsColumnsKey?.includes(header.id) && !!row?.className) ? row.className : ''
                      ]"
          [tooltip]="(getRowTooltipConfig(headerIdx)?.show && getRowTooltipConfig(headerIdx)?.dataProperty === header.id) && row['tooltip' + header.id] && tooltip"
          [placement]="getRowTooltipConfig(headerIdx)?.position || 'bottom'" containerClass="table-tooltip">
          @switch (getRowExceptionRules( rowIdx, headerIdx )?.type || header.type) {
            @case ('percent') {
              @if (row.hasOwnProperty( header.id )) {
                {{ ( getRowExceptionRules( rowIdx, headerIdx )?.value || row[header.id] ) / 100 | percent }}
              }
            }
            @case ('input') {
              @if (row.hasOwnProperty( header.id )) {
                @if (( row.hasOwnProperty( 'isDisabled' ) && row.isDisabled ) || ( row.hasOwnProperty( 'isEditable' )
                  && !row.isEditable )) {
                  <div class="tw-text-center">{{ getRowExceptionRules( rowIdx, headerIdx )?.value || row[header.id] }}</div>
                } @else {
                  <input
                    class="tw-text-right tw-outline-none tw-border-b tw-border-charcoal-800 placeholder:tw-text-charcoal-600 tw-py-1 tw-pl-1 !tw-rounded-none focus:tw-border-x-0 focus:tw-border-t-0 focus:!tw-border-b focus:!tw-border-green-700 hover:!tw-border-b hover:!tw-border-green-700"
                    [ngStyle]="{maxWidth: header.width}"
                    [ngModel]="getRowExceptionRules( rowIdx, headerIdx )?.value || row[header.id]" type="text" name="text-input"
                    [placeholder]="getRowPlaceholderConfig(headerIdx)"
                    (keyup)="handleTableDataChange(rowIdx, header.id, textInput.value,subRowIdx); resetUpdateDataTriggerCount()"
                    (blur)="handleCancelOrConfirmTableData(rowIdx, header.id, textInput.value,subRowIdx); resetUpdateDataTriggerCount()"
                    (keydown.enter)="handleCancelOrConfirmTableData(rowIdx, header.id, textInput.value,subRowIdx); textInput.blur()"
                    (keydown.escape)="textInput.value = row[header.id]; textInput.blur()"
                    (click)="$event.stopPropagation()"
                    (mouseover)="handleOnMouseoverInputField()"
                    (mouseleave)="handleOnMouseleaveInputField()" appNumbersValidation #textInput/>
                  }
                }
              }
              @case ('input_percentage') {
                @if (row.hasOwnProperty( header.id )) {
                  @if (( row.hasOwnProperty( 'isDisabled' ) && row.isDisabled ) || ( row.hasOwnProperty( 'isEditable' )
                    && !row.isEditable )) {
                    <div>{{ getRowExceptionRules( rowIdx, headerIdx )?.value || row[header.id] }}</div>
                  } @else {
                    <input
                      class="tw-text-right tw-relative tw-outline-0 tw-border-b tw-w-auto tw-border-charcoal-800 placeholder:tw-text-charcoal-600 tw-p-1 !tw-rounded-none focus:tw-border-x-0 focus:tw-border-t-0 focus:!tw-border-b focus:!tw-border-green-700 hover:!tw-border-b hover:!tw-border-green-700 [&::-webkit-inner-spin-button]:tw-h-0 [&::-webkit-outer-spin-button]:tw-h-0 "
                      [ngStyle]="{ width: header.width, whiteSpace: header.width ? 'normal' : 'inherit'}"
                      [ngModel]="getRowExceptionRules( rowIdx, headerIdx )?.value || row[header.id]" type="number" name="number-input"
                      [placeholder]="getRowPlaceholderConfig(headerIdx)"
                      (blur)="handleTableDataChange(rowIdx, header.id, numberInput.value,subRowIdx); resetUpdateDataTriggerCount()"
                      (keydown.enter)="handleTableDataChange(rowIdx, header.id, numberInput.value,subRowIdx); numberInput.blur(); resetUpdateDataTriggerCount()"
                      (keydown.escape)="numberInput.value = row[header.id]; numberInput.blur()"
                      (click)="$event.stopPropagation()"
                      (mouseover)="handleOnMouseoverInputField()" (mouseleave)="handleOnMouseleaveInputField()"
                      appSuffix suffix="%" #numberInput/>
                    }
                  }
                }
                @case ('switch_button') {
                  @if (row.hasOwnProperty( header.id )) {
                    <nz-switch [ngModel]="getRowExceptionRules( rowIdx, headerIdx )?.value || row[header.id]"
                      (click)="$event.stopPropagation()"
                      (ngModelChange)="handleTableDataChange(rowIdx, header.id, $event,subRowIdx); resetUpdateDataTriggerCount()"
                    [nzDisabled]="( row.hasOwnProperty( 'isDisabled' ) && row.isDisabled ) || ( row.hasOwnProperty( 'isEditable' )&& !row.isEditable )"></nz-switch>
                  }
                }
                @case ('icon') {
                  <div>
                    @if (row.hasOwnProperty( header.id )) {
                      @switch (getRowExceptionRules( rowIdx, headerIdx )?.value || row[header.id]) {
                        <!-- Cases here not injected dynamically, however you may need to adjust it according to you needs and project -->
                        @case ('GREEN') {
                          <i [class]="'tw-text-[20px] tw-cursor-pointer ' + row['capacityIcon']"
                            [ngClass]="row.capacityEnabled ? 'tw-text-green-650 hover:tw-text-green-700 tw-transition' : 'tw-text-disabled-color tw-opacity-75'"
                            (click)="handleTableDataChange(rowIdx, header.id, row['departureId'], subRowIdx,true)"
                          (mouseover)="handleOnMouseoverInputField()" (mouseleave)="handleOnMouseleaveInputField()"></i>
                        }
                        @case ('RED') {
                          <i [class]="'tw-text-[20px] tw-cursor-pointer ' + row['capacityIcon']"
                            [ngClass]="row.capacityEnabled ? 'tw-text-alert_red-600 hover:tw-text-alert_red-700 tw-transition' : 'tw-text-disabled-color tw-opacity-75'"
                            (click)="handleTableDataChange(rowIdx, header.id, row['departureId'], subRowIdx,true)"
                          (mouseover)="handleOnMouseoverInputField()" (mouseleave)="handleOnMouseleaveInputField()"></i>
                        }
                        @case ('Auto Confirmed') {
                          <i class="bi bi-check-circle tw-text-[20px]"
                          [ngClass]="row.isExported ? 'tw-text-disabled-color tw-opacity-70' : 'tw-text-green-650'"></i>
                        }
                        @case ('Confirmed Single Supplement') {
                          <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" style="color: #4DC7CA">
                            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.8"/>

                            <circle cx="9" cy="9" r="1.8" fill="currentColor"/>
                            <circle cx="15" cy="15" r="1.8" fill="currentColor"/>
                            <line x1="15" y1="8" x2="9" y2="16" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                          </svg>

                        }

                        @case ('Rejected') {
                          <i class="bi bi-x-circle tw-text-[20px]"
                          [ngClass]="row.isExported ? 'tw-text-disabled-color tw-opacity-70' : 'tw-text-alert_red-600'"></i>
                        }
                        @case ('Confirmed') {
                          <i class="bi bi-check2-all tw-text-[20px]"
                          [ngClass]="row.isExported ? 'tw-text-disabled-color tw-opacity-70' : 'tw-text-green-650'"></i>
                        }
                      }
                    }
                  </div>
                }
                @case ('select_input') {
                  @if (row.hasOwnProperty( header.id )) {
                    @if (( row.hasOwnProperty( 'isDisabled' ) && row.isDisabled ) || ( row.hasOwnProperty( 'isEditable' )
                      && !row.isEditable )) {
                      <div>
                        {{
                        getTheNameOfTheItemFromSelectInputList( headerIdx,
                        getRowExceptionRules( rowIdx, headerIdx )?.value || row[header.id] )
                        }}
                      </div>
                    } @else {
                      <div (mouseover)="handleOnMouseoverInputField()" (mouseleave)="handleOnMouseleaveInputField()">
                        <nz-select
                          class="table-select-input"
                          [nzBackdrop]="false"
                          [nzDropdownMatchSelectWidth]="true"
                          [nzId]="'select-input-'+rowIdx+'-'+headerIdx"
                          [ngModel]="getRowExceptionRules( rowIdx, headerIdx )?.value || row[header.id]"
                          [nzPlaceHolder]="'common.select' | translate"
                          (ngModelChange)="handleTableDataChange(rowIdx, header.id, $event,subRowIdx); resetUpdateDataTriggerCount()"
                          [nzDropdownClassName]="'table-select-dropdown-' + header.id">
                          @for (item of getRowSelectInputConfig(headerIdx); track item) {
                            <nz-option [nzValue]="item.value"
                            [nzLabel]="item.label" [nzDisabled]="item['disabled']!"></nz-option>
                          }
                        </nz-select>
                      </div>
                    }
                  }
                }
                @case ('link') {
                  @if(role!=='PARENT'){
                    <div class="tw-flex tw-justify-between tw-w-full">
                      <div (click)="handleOnLinkTypeCellClick(row,parentRow)" (mouseover)="handleOnMouseoverInputField()"
                        (mouseleave)="handleOnMouseleaveInputField()">
                        {{ getRowExceptionRules( rowIdx, headerIdx )?.value || row[header.id] }}
                      </div>
                    </div>
                    }@else{
                    <div [innerHTML]="getRowExceptionRules( rowIdx, headerIdx )?.value || row[header.id]"></div>
                  }
                }
                @case ('alert') {
                  <div class="tw-flex tw-justify-between tw-w-full tw-gap-x-2" nz-tooltip
                    [nzTooltipTitle]="alertsTpl"
                    nzTooltipOverlayClassName="white-tooltip"
                    nzTooltipPlacement="right">
                    @for (icon of row['alerts']; track icon.icon){
                      @if(icon.icon){
                        <img [src]="'../../../../assets/images/svg/'+icon.icon+'.svg'" [alt]="icon.description"/>
                        }@else{
                        <div class="tw-w-6 tw-h-6"></div>
                      }

                    }
                    <ng-template #alertsTpl>
                      <div class="tw-text-left tw-my-2">
                        <div class="tw-p-2">Alerts in effect</div>
                        <div class="tw-h-[1px] tw-w-full tw-bg-purple-450"></div>
                        <div class="tw-p-2">
                          @for (icon of row['alerts']; track icon.icon){
                            @if(icon.icon){
                              <div class="tw-flex tw-items-start tw-gap-2">
                                <img [src]="'../../../../assets/images/svg/'+icon.icon+'.svg'" [alt]="icon.description" class="tw-w-4"/>
                                <span>{{icon.description}}</span>
                              </div>
                            }
                          }
                        </div>
                      </div>
                    </ng-template>
                  </div>
                }
                @default {
                  <div [innerHTML]="getRowExceptionRules( rowIdx, headerIdx )?.value || row[header.id]"></div>
                }
              }

            </span>


          </div>
        }
      </td>

    </ng-template>
